<template>
  <v-row no-gutters justify="center" :class="{ 'table-buttons-edit-change': hasAdditionalTools && isActive }">
    <v-col cols="auto">
      <table-button
        name="button-edit-move-rotate"
        v-bind="{
          ...$props,
          ...$attrs,
          disableCursor: isActive,
        }"
        @click="toggle"
        :buttonSize="hasAdditionalTools && isActive ? 'small' : 'default'"
      />
    </v-col>
    <v-col cols="auto" v-if="hasAdditionalTools && isActive">
      <v-menu offset-x attach style="position: relative;">
        <template #activator="{ on }">
          <table-button
            v-on="isModifyMultipartActive ? null : on"
            @click="isModifyMultipartActive && handleAction()"
            v-bind="multipartInputs[geometryType]"
          />
        </template>
        <v-list dense>
          <v-list-item
            v-for="(item, idx) in multiGeometryOptions"
            v-bind="item"
            @click="handleAction(item.value)"
            :key="idx"
          >
            <v-list-item-content>
              <v-list-item-title class="text-left">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify';
import TableButton from '@/components/TableButton';
import geometryTypeMapping from '@/mixins/map/geometryTypeMapping';

export default {
  name: 'TableButtonsEditChangeGeometry',
  components: { TableButton },
  mixins: [geometryTypeMapping],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
    },
    geometryType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isDeleteMultipartDisabled: true,
  }),
  watch: {
    editModifyWatcherTrigger: {
      handler() {
        if (this.isModifyMultipartActive || !this.hasAdditionalTools) return;
        this.$root.$emit('getLayerContextById', {
          id: 'drawingSidebarLayer',
          callback: layer => {
            if (!layer) return;
            const geom = layer
              ?.getSource()
              ?.getFeatures()?.[0]
              ?.getGeometry();
            if (!geom) return;
            this.isDeleteMultipartDisabled =
              geom[`get${this.getOlGeometrySimpleType(this.getOlGeometryTypeFromLayerGeometry(this.geometryType))}s`]()
                .length <= 1;
          },
        });
      },
      immediate: true,
    },
  },
  computed: {
    isEditingButtonActive: sync('edit/isEditingButtonActive'),
    isModifyMultipartActive: sync('edit/isModifyMultipartActive'),
    editModifyWatcherTrigger() {
      return `${this.isEditingButtonActive}|${this.isModifyMultipartActive}`;
    },
    multipartInputs() {
      return {
        /** Subject to change on different multigeometries */
        multipolygon: {
          name: 'multipolygon-button-edit-modify',
          icon: '$multiPolygon',
          color: 'success',
          fontSize: '19px',
          buttonSize: 'small',
          tooltip: this.$i18n.t(this.isModifyMultipartActive ? 'button.addDeletePartDisable' : 'button.addDeletePart'),
        },
      };
    },
    multiGeometryOptions() {
      return this.getGeometryTypesOptions(this.geometryType);
    },
    hasAdditionalTools() {
      return ['multipolygon'].includes(this.geometryType);
    },
  },
  methods: {
    handleAction(name) {
      this.$root.$emit('toggleMultipartFeatureManagement', name);
    },
    getGeometryTypesOptions(type) {
      const addPart = {
        value: 'add_part',
        text: this.$i18n.t('button.addMultipart'),
      };
      const deletePart = {
        value: 'delete_part',
        disabled: this.isDeleteMultipartDisabled,
        text: this.$i18n.t('button.deleteMultipart'),
      };
      switch (type) {
        case 'multipolygon':
          return [
            addPart,
            {
              value: 'add_part_parcel',
              text: this.$i18n.t('button.addMultipartParcel'),
            },
            deletePart,
          ];
        default:
          return [addPart, deletePart];
      }
    },
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>
<style lang="scss" scoped>
.table-buttons-edit-change {
  border-radius: 5px;
  background-color: map-get($colors, 'primarybackground');
}
</style>
